
<div class="h-100 w-100">
    <c-site-contract-flip-card
        v-if      = "contractValid"
        :title    = "$t('contract.esc.title')"
        :contract = "contract"
        :edit     = "true"
        :unit     = "unit"
        @readonly = "onReadonly"
        @store    = "onStore"
    >
        <template v-slot:front>
            <f-title
                class  = "mt-3"
                :title = "$t('contract.terms')"
            />

            <v-row class="no-frame mb-2">
                <v-col class="no-frame">
                    <f-enum-select-rw
                        v-model       = "contract.unit.gadget"
                        :label        = "$t('contract.esc.gadgetRent')"
                        :readonly     = "readonly"
                        module        = "msd"
                        type          = "escGadgetRentType"
                        :hide-details = "true"
                    />
                </v-col>
            </v-row>

            <v-row class="no-frame mb-2">
                <v-col class="no-frame pr-2">
                    <f-currency-field-rw
                        :label    = "$t('contract.esc.costs')"
                        :readonly = "readonly"
                        v-model   = "contract.unit.costs"
                    />
                </v-col>
                <v-col class="no-frame p-2">
                </v-col>
            </v-row>

            <v-row class="no-frame mb-2">
                <v-col class="no-frame pr-2">
                    <f-currency-field-rw
                        :label    = "$t('contract.esc.rentPerYear')"
                        :readonly = "readonly"
                        v-model   = "contract.unit.rent"
                    />
                </v-col>
                <v-col class="no-frame p-2">
                    <f-currency-field-rw
                        :label    = "$t('contract.esc.standByPerYear')"
                        :readonly = "readonly"
                        v-model   = "contract.unit.standBy"
                    />
                </v-col>
            </v-row>

            <v-row class="no-frame">
                <v-col class="no-frame pr-2">
                    <f-currency-field-rw
                        :label    = "$t('contract.esc.phoneCosts')"
                        :readonly = "readonly"
                        v-model   = "contract.unit.phoneCosts"
                    />
                </v-col>
                <v-col class="no-frame p-2">
                    <f-currency-field-rw
                        :label    = "$t('contract.esc.guardCosts')"
                        :readonly = "readonly"
                        v-model   = "contract.unit.guardCosts"
                    />
                </v-col>
            </v-row>
        </template>
    </c-site-contract-flip-card>

    <div
        v-if  = "!contractValid"
        class = "w-100 h-100"
    >
        <c-column-header
            label = "Notruf (kein Vertrag)"
            class = "primary mb-1 w-100"
        />
        <div class  = "lm-border mb-1 w-100" style="height: calc(100% - 29px)">

        </div>
    </div>
</div>
